import React from 'react';

/** @internal */
export var alertIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7808 11.4214H9.23193L8.9082 5.21973H11.1045L10.7808 11.4214ZM8.88281 13.5923C8.88281 13.2368 8.97803 12.9681 9.16846 12.7861C9.35889 12.6042 9.63607 12.5132 10 12.5132C10.3512 12.5132 10.6221 12.6063 10.8125 12.7925C11.0072 12.9787 11.1045 13.2453 11.1045 13.5923C11.1045 13.9266 11.0072 14.1911 10.8125 14.3857C10.6178 14.5762 10.347 14.6714 10 14.6714C9.64453 14.6714 9.36947 14.5783 9.1748 14.3921C8.98014 14.2017 8.88281 13.9351 8.88281 13.5923Z",
  fill: "white"
}));